import styled from 'styled-components';

export const YamlEditorWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  overflow: auto;
  background-color: ${({ theme }) => theme.colorBgContainer};

  /* Create new stacking context to isolate CodeMirror's z-index values */
  z-index: 0;
  transform: translateZ(0);

  /* Prevent Ant Design global styles from interfering */
  * {
    box-sizing: border-box;
  }

  /* Isolate CodeMirror from external CSS */
  .cm-editor {
    isolation: isolate;
  }

  .cm-editor {
    height: 100%;
  }

  .cm-content {
    padding: ${({ theme }) => theme.padding}px;
  }

  .cm-line {
    padding: 0 ${({ theme }) => theme.paddingXXS}px;
  }

  .cm-gutters {
    background-color: ${({ theme }) => theme.colorBgLayout};
    border-right: ${({ theme }) => theme.lineWidth}px solid
      ${({ theme }) => theme.colorBorderSecondary};
    color: ${({ theme }) => theme.colorTextTertiary};
  }

  .cm-activeLineGutter {
    background-color: ${({ theme }) => theme.colorFillAlter};
  }

  .cm-activeLine {
    background-color: transparent;
  }

  .cm-cursor {
    border-left-color: ${({ theme }) => theme.colorPrimary};
  }

  .cm-searchMatch {
    background-color: ${({ theme }) => theme.colorWarningBg};
    outline: 1px solid ${({ theme }) => theme.colorWarningBorder};
  }

  .cm-searchMatch.cm-searchMatch-selected {
    background-color: ${({ theme }) => theme.colorSuccessBg};
  }

  /* Text selection styling - proper approach with translucent background */
  .cm-selectionBackground {
    background-color: ${({ theme }) => theme.colorPrimaryBg} !important;
    opacity: 0.6 !important;
  }

  .cm-selectionLayer .cm-selectionBackground {
    background-color: ${({ theme }) => theme.colorPrimaryBg} !important;
    opacity: 0.6 !important;
  }

  /* Ensure content backgrounds don't interfere */
  .cm-content {
    background-color: transparent !important;
  }

  .cm-line {
    background-color: transparent !important;
  }

  /* Fallback for native selection */
  ::selection {
    background-color: ${({ theme }) => theme.colorPrimaryBg};
  }

  /* Light theme overrides */
  .cm-theme-light {
    .cm-content {
      background-color: transparent !important;
      color: ${({ theme }) => theme.colorText};
    }

    .cm-gutters {
      background-color: ${({ theme }) => theme.colorFillQuaternary};
    }
  }

  /* Syntax highlighting for light theme */
  .cm-theme-light {
    .cm-comment {
      color: ${({ theme }) => theme.colorTextTertiary};
    }

    .cm-string {
      color: #0a3069;
    }

    .cm-number {
      color: #005cc5;
    }

    .cm-keyword {
      color: #d73a49;
    }

    .cm-property {
      color: #6f42c1;
    }

    .cm-bool {
      color: #005cc5;
    }

    .cm-null {
      color: #d73a49;
    }
  }

  /* Dark theme selection styling */
  &.cm-theme-dark {
    .cm-selectionLayer .cm-selectionBackground {
      background-color: rgba(255, 255, 255, 0.1) !important;
    }

    ::selection {
      background-color: rgba(255, 255, 255, 0.1);
    }
  }
`;
